<template>
  <v-layout>
    <v-flex>
      <v-card>
        <v-card-title>
          <h1 class="headline">GT Templates Importer</h1>

          <v-spacer></v-spacer>
          <v-dialog v-model="loading" persistent width="300">
            <v-card color="primary" dark>
              <v-card-text>
                Importing Templates...
                <v-progress-linear
                  indeterminate
                  color="white"
                  class="mb-0"
                ></v-progress-linear>
              </v-card-text>
            </v-card>
          </v-dialog>
          <v-btn v-if="false">Filters to Implement</v-btn>
        </v-card-title>
        <hr />
        <v-layout wrap align-center>
          <v-spacer></v-spacer>
          <v-btn
            :disabled="selected.length == 0"
            @click="onImportSelected"
            :loading="loading"
          >
            Import Selected Templates
            <v-icon right dark>mdi-upload</v-icon>
          </v-btn>
          <v-flex xs12 sm4 class="pa-2">
            <v-text-field
              append-icon="mdi-magnify"
              label="Quick Filter..."
              single-line
              hide-details
              v-model="search"
              solo
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout fluid>
          <v-flex xs12>
            <v-data-table
              v-model="selected"
              :headers="headers"
              :items="items"
              :loading="$apollo.loading && !loading"
              item-key="id"
              show-select
              class="elevation-1"
              v-bind="pagingOptions"
              :search="search"
            >
              <template v-slot:items="props">
                <td>
                  <v-checkbox
                    v-model="props.selected"
                    primary
                    hide-details
                  ></v-checkbox>
                </td>
                <td>{{ props.item.name }}</td>
                <td>{{ props.item.pricingDate | formatDate }}</td>
                <td>{{ props.item.destinationName }}</td>
                <td>{{ props.item.agentName }}</td>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-card>
      <get-more-results
        :first="first"
        @limitChange="onLimitChange"
        :items="gtwebTemplates"
        :totalItems="totalItems"
        :loading="$apollo.loading"
        :loadMoreEnabled="loadMoreEnabled"
        @loadMore="loadMore('gtwebTemplates')"
      ></get-more-results>
    </v-flex>
    <div v-if="debug">
      <p>load more enabled : {{ loadMoreEnabled }}</p>
    </div>
  </v-layout>
</template>

<script>
import { ALL_GTWEB_TEMPLATES_SEARCH_QUERY } from "../../../constants/graphql";
import { ListMixin } from "../../../mixins/ListMixin";
import GetMoreResults from "../shared/GetMoreResults";
import gql from "graphql-tag";
import { sortByDate } from "../../../helpers/index";

const IMPORT_GTWEB_TEMPLATES_MUTATION = gql`
  mutation ($templates: [ID]!) {
    task: importGtWebTemplates(templates: $templates) {
      id
      status
    }
  }
`;
const IMPORT_STATUS = gql`
  query ($taskId: ID!) {
    importStatus: taskStatus(id: $taskId) {
      status
      notes
    }
  }
`;
export default {
  name: "GTTemplatesImporter",
  mixins: [ListMixin],
  components: { GetMoreResults },
  data() {
    return {
      debug: false,
      search: "",
      selected: [],
      headers: [
        { text: "Name", value: "name" },
        { text: "Pricing Date", value: "pricingDate", sort: sortByDate },
        { text: "Destination", value: "destinationName" },
        { text: "Agent", value: "agentName" },
      ],
      taskId: null,
      checkStatus: false,
      loading: false,
    };
  },
  computed: {
    items() {
      return this.gtwebTemplates
        ? this.gtwebTemplates.edges.map((item) => ({ ...item.node }))
        : [];
    },
    selectedTemplates() {
      return this.selected.map((i) => i.id);
    },
  },
  methods: {
    async onImportSelected(e) {
      try {
        this.loading = true;
        const data = await this.$apollo.mutate({
          mutation: IMPORT_GTWEB_TEMPLATES_MUTATION,
          variables: {
            templates: this.selectedTemplates,
          },
        });
        this.taskId = data.data.task.id;
        this.checkStatus = true;
      } catch (error) {
        console.error(error);
      }
    },
  },
  apollo: {
    gtwebTemplates: {
      query: ALL_GTWEB_TEMPLATES_SEARCH_QUERY,
      variables() {
        return {
          after: this.after,
          filter: this.searchParams,
        };
      },
      result({ data, loader, networkStatus }) {
        this.totalItems = data.gtwebTemplates.totalCount;
      },
      fetchPolicy: "network-only",
    },
    importStatus: {
      query: IMPORT_STATUS,
      variables() {
        return { taskId: this.taskId };
      },
      result({ data, loader, networkStatus }) {
        this.checkStatus = false;
        const status = data.importStatus.status;
        if (status == "IN_PROGRESS") {
          setTimeout(() => {
            this.checkStatus = true;
          }, 2000);
        } else {
          if (status == "ERROR") {
            //show error message
            console.error(data.importStatus.notes);
          }
          this.loading = false;
          this.checkStatus = false;
        }
      },
      skip() {
        return !this.checkStatus;
      },
      fetchPolicy: "network-only",
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/templates/GTTemplatesImporter.vue